import DeviceDetailsPage from "./DeviceDetailsPage";
import withApiErrorWrapper from "../HandleApiErrorWrapperNonRedux";
import DeviceDetailsPageWrapper from "./DeviceDetailsPageWrapper";
import { compose } from "recompose";

export default compose(
  withApiErrorWrapper,
  DeviceDetailsPageWrapper
)(DeviceDetailsPage);
